import { render, staticRenderFns } from "./CollapsedArrow.vue?vue&type=template&id=48f82dd1&scoped=true"
import script from "./CollapsedArrow.vue?vue&type=script&lang=js"
export * from "./CollapsedArrow.vue?vue&type=script&lang=js"
import style0 from "./CollapsedArrow.vue?vue&type=style&index=0&id=48f82dd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f82dd1",
  null
  
)

export default component.exports